import ApiCallManager from './apiCallManager';
import Media from './media';

/**
 * @ngdoc class
 * @name Campaign
 * @description
 * This class represent a Campaign.
 *
 * @memberof common
 */
class Campaign extends ApiCallManager {
  /**
   * Class constructor.
   * @param {Service} appUtils             The service to get the page query param.
   * @param {Object} campaign              The necesary data to build the Campaign.
   * @param {Service} contentCreatorAppAPI The API to call the BE.
   * @ignore
   */
  constructor(appUtils, campaign, contentCreatorAppAPI) {
    super(
      appUtils,
      (content) => content.map((item) => new Media(item)),
      contentCreatorAppAPI.getCampaignMedia.bind(contentCreatorAppAPI),
      [campaign.id],
    );

    /**
     * The local reference to the `id` property.
     * @type {String}
     */
    this.id = campaign.id;
    /**
     * The local reference to the `cover_image` property.
     * @type {String}
     */
    this.coverImage = campaign.cover_image;
    /**
     * The local reference to the `name` property.
     * @type {String}
     */
    this.name = campaign.name;
    /**
     * The local reference to the `short_description` property.
     * @type {String}
     */
    this.shortDescription = campaign.short_description;
    /**
     * The local reference to the `long_description` property.
     * @type {String}
     */
    this.longDescription = campaign.long_description;
    /**
     * The local reference to the `guidelines` property.
     * @type {Array}
     */
    this.guidelines = campaign.guidelines;
    /**
     * The local reference to the `media` property.
     * @type {Array}
     */
    this.media = [];

    // Start fetching the campaign media
    this.load(true);
  }
  /**
   * Get the Campaigns list from the BE.
   * @param {Boolean} refresh flag to force a refresh of the Media.
   * @return {Promise}
   */
  getMedia(refresh) {
    return this._getContent(refresh).then((media) => {
      this.media = media;
      return media;
    });
  }
  /**
   * Get a Media by its Id.
   * @return {Promise}
   */
  getMediaById(mediaId) {
    return this._getContentById(mediaId);
  }
  /**
   * Handle the load of the content.
   * @param {Boolean} first flag to get the Media
   *                  for the first time or load more.
   * @return {Promise}
   */
  load(first) {
    return super.load(first).then((media) => {
      this.media = media;
      return media;
    });
  }
}

export default Campaign;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/models/campaign.js